import { NgModule } from '@angular/core';
import { GlobalModule } from '../global/global.module';
import { ButtonsService } from './buttons.service';
import { ButtonsMyComponent } from './myButtons/myButtons.component';
import { STATES } from './buttons.states';
import { UIRouterModule } from '@uirouter/angular';
import { ButtonsSingleComponent } from './single/single.component';

@NgModule({
  declarations: [
    ButtonsMyComponent,
    ButtonsSingleComponent
  ],
  providers: [
    ButtonsService
  ],
  imports: [
    GlobalModule,
    UIRouterModule.forChild({states: STATES})
  ]
})
export class ButtonsModule {
}


// WEBPACK FOOTER //
// ./src/app/buttons/buttons.module.ts